const catalogoNotificadores = {
    C001Cedula: 'SINOJ/Catalogos/GetCedula',
    C002TiposCedula: 'SINOJ/Catalogos/GetTiposCedula',
    C003Jurisdicciones: 'SINOJ/Catalogos/GetJurisdicciones',
    C009TiposPlantilla: 'SINOJ/Catalogos/GetTiposPlantilla',
    C019Fracionamientos: 'SINOJ/Catalogos/GetFraccionamientos',
    C021TiposZonas: 'SINOJ/Catalogos/GetZonas',
    C021Zona: 'SINOJ/Catalogos/GetZona',
    C007TiposEmpresas: 'SINOJ/Catalogos/GetEmpresas',
    C007RepresentantesLegalesdeEmpresa: 'SINOJ/Catalogos/GetRepresentantesLegalesdeEmpresa',
    C020TiposNotificadores: 'SINOJ/Catalogos/GetNotificadores',
    C020TiposNotificadoresConAsignacion:'SINOJ/Catalogos/GetNotificadoresConAsignaciones',
    C020Notificador: 'SINOJ/Catalogos/GetNotificador',
    C015TiposDeResultado: 'SINOJ/Catalogos/GetTiposDeResultado',
    C022TiposDeRazones: 'SINOJ/Catalogos/GetTiposDeRazones',
    C011TiposEstatus: 'SINOJ/Catalogos/GetTiposDeEstatus',
    C028Marcadores: 'SINOJ/Catalogos/GetMarcadores',

    /* SISTEMA VIEJO */
    CCatEstatusNotif: 'SINOJ/Catalogos/SistemaViejo/GetTiposEstatus',
    CCatTipoNotificacion: 'SINOJ/Catalogos/SistemaViejo/GetTiposNotificaciones',
    CCatTipoDocumento: 'SINOJ/Catalogos/SistemaViejo/GetTiposDeDocumentos'
};

export default catalogoNotificadores;



//////////////////
// WEBPACK FOOTER
// ./static/js/api/SINOJ/catalogos/catalogosSINOJ.js
// module id = null
// module chunks = 